// =============================================================================
// SITE CONFIGURATION — Chez Camille (Montrouge)
// =============================================================================
// Master configuration for Chez Camille crêperie website.
// Controls styling, localization, reservations, SEO, and integrations.
// =============================================================================

import type { SiteConfig } from '@webzite/content-schema';

const siteConfig: SiteConfig = {
  // =========================================================================
  // VISUAL STYLE
  // =========================================================================
  // Red Velvet Bistro style pack — warm bistro atmosphere, noir black, amber gold.
  stylePack: 'red-velvet-bistro',

  // =========================================================================
  // GEOGRAPHIC REGION
  // =========================================================================
  // European Union — EU-14 allergen regulations, GDPR cookie consent.
  region: 'eu',

  // =========================================================================
  // LANGUAGE & LOCALIZATION
  // =========================================================================
  defaultLocale: 'fr',
  locales: ['fr', 'en', 'zh', 'de', 'it', 'pt'],
  currency: 'EUR',

  // =========================================================================
  // RESERVATIONS
  // =========================================================================
  reservations: {
    enabled: true,
    provider: 'custom',
    bookingUrl: 'tel:+33676285594',
  },

  // =========================================================================
  // DELIVERY PLATFORMS
  // =========================================================================
  delivery: {
    enabled: false,
    platforms: [],
  },

  // =========================================================================
  // MAP
  // =========================================================================
  maps: {
    provider: 'osm',
    embedUrl:
      'https://www.openstreetmap.org/export/embed.html?bbox=2.3160,48.8145,2.3260,48.8195&layer=mapnik&marker=48.8171494,2.3210304',
    googleMapsLink:
      'https://www.google.com/maps/place/Chez+Camille/@48.8171494,2.3184555,17z/data=!4m8!3m7!1s0x47e6717bad9804d5:0x49f93b3573d745ac!8m2!3d48.8171494!4d2.3210304!9m1!1b1!16s%2Fg%2F11z9tj8pdn',
    appleMapsLink:
      'https://maps.apple.com/?q=Chez+Camille+5+Rue+Sadi+Carnot+92120+Montrouge',
  },

  // =========================================================================
  // ANALYTICS
  // =========================================================================
  analytics: {
    cloudflare: { enabled: true },
    ga4: {
      enabled: false,
      measurementId: '',
    },
  },

  // =========================================================================
  // SEO (Search Engine Optimization)
  // =========================================================================
  seo: {
    titleTemplate: '%s | Chez Camille — Crêperie Traditionnelle Bretonne · Montrouge',
    defaultDescription:
      'Crêperie bretonne au 5 Rue Sadi Carnot, 92120 Montrouge. Galettes 100% bio du Moulin de l\'Écluse, crêpes gourmandes et cidre artisanal Kerné.',
    ogImage: '/images/og-image.png',
  },

  // =========================================================================
  // DEVELOPER ATTRIBUTION & WATERMARK
  // =========================================================================
  developer: {
    name: 'jeduapf',
    url: 'https://portfolio.jeduapf.com',
    role: 'Restaurant Web Developer',
    showFooterCredit: true,
  },

  // =========================================================================
  // ALLERGEN REGULATION
  // =========================================================================
  allergenRegulation: 'eu-fic-1169',
};

export default siteConfig;
